import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import MoneyUnit決算期TableHeader from '@/components/moneyUnit決算期TableHeader/MoneyUnit決算期TableHeader.vue';
import C貸借損益TableRow from '@/components/貸借損益TableRow/貸借損益TableRow.vue';

import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';

import { 計画Plbscf } from '@/classes/service/Abstract計画PlbscfService';
import 計画PlbscfService from '@/classes/service/計画/計画PlbscfService';

export default mixins(PlbscfKeystrokeResetMixin).extend({
  name: 'M計画三表Mixin',

  props: {
    service: {
      type: Object as PropType<計画PlbscfService>,
      required: true,
    },
    計画Plbscf: {
      type: Object as PropType<計画Plbscf>,
      required: true,
    },
  },

  components: {
    MoneyUnit決算期TableHeader,
    C貸借損益TableRow,
  },

  mounted(): void {
    this.addKeystrokeResetCount();
  },
});
